import config from './survey-with-slash.config';
import directive from './survey-with-slash.directive';

export default function(app) {
	app.config(config);
	app.directive('surveyWithSlash', directive);
}


// WEBPACK FOOTER //
// ./app/components/survey-with-slash/index.js